module.exports = __webpack_public_path__ + "static/media/pic_fy_building.56822eae.png";